import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axios from 'axios';
import SweetAlert from 'react-bootstrap-sweetalert';
import Footer from "../../components/dashboard/footer";
import Header from "../../components/dashboard/header";
import moment from "moment";
import Sidebar from "../../components/dashboard/sidebar";
import { contentContext } from "../../context/contentContext";
import SessionPopup from "../../pages/SessionPopup";
// import LocationSearch from "../LocationSearch";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Modal from 'react-bootstrap/Modal';
//  import { withGoogleMap, GoogleMap, withScriptjs} from "react-google-maps";
import { GoogleMap, LoadScript } from "@react-google-maps/api";
import Theme from "../../pages/visitorSettingsConfiguration/Theme";
let { lambda, appname } = window.app
const LandingScreen = () => {
    let { id } = useParams();
    const navigate = useNavigate();
    const { state } = useLocation();
    // const [isLoading, setIsLoading] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const userId = localStorage.getItem("userId");
    const loginType = localStorage.getItem('login_type'); // 'admin' or 'client'
    // // console.log('loginType',loginType,localStorage.getItem("clientid"));
    const useruniqueid = localStorage.getItem("userId")
    // console.log('useruniqueid', useruniqueid);
    const { searchedFlag, setSearchedFlag, clientmanagesearch, setClientMangeSearch, isLoading, setIsLoading, userData, setUserData, GetClientDataContext, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, usersearch, setUserSearch, currentPage, setcurrentPage, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, GetTimeActivity } = useContext(contentContext)
    const [add, setAdd] = useState(false);
    const [message, setMessage] = useState(false);
    const [loaderEnable, setLoaderEnable] = useState(false);
    const [selectedPlace, setSelectedPlace] = useState('');
    const [addressData, setAddressData] = useState({});
    const [formData, setFormData] = useState({
        name: "",
        tagline: "",
        textButton: "",
        logo: "",
        image: ""
    });
    const [filesData, setFilesData] = useState({ logo: null, image: null });
    const [fileSizeError, setFileSizeError] = useState(false);
    const [btnLoader, setBtnLoader] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [toastType, setToastType] = useState("");
    const [activeTab, setActiveTab] = useState("landingScreen");
    const [image, setImg] = useState("");
    const [errors, setErrors] = useState({});
    const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu === "Visitor App Settings")
    const subValDashboard = validateObj && validateObj[0] && validateObj[0].dashboard
    useEffect(() => {

    }, [])
    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }


    }, [window.site]);
    useEffect(() => {

        if (!localStorage.getItem("token")) {
            navigate("/");
        }
        setRoute("client")
        setActiveMenuId(200007)
        userActivity();

    }, []);

    useEffect(() => {
        getLandingTheme()

    }, []);
    const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = path[path.length - 1];
        var presentTime = moment();
        let payload;

        payload = {
            "userid": localStorage.getItem("userId"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };


        const previousId = localStorage.getItem("previousid");
        const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    localStorage.setItem("previousid", response?.data?.result)
                }
            });
    }

    const handleActiveTab = (tab) => {
        // if (tab === "landingScreen") {
        //    // setData(transactionsData?.transactions)
        //    // setColumns(clientsColumns)
        //     // setCurrentPage(1)
        //     // setRowsPerPage(15)
        // } else {
        //     //setData(transactionsData?.visirorTransactions)
        //   //  setColumns(visitorsColumns)
        //     setCurrentPage(1)
        //     setRowsPerPage(15)
        // }
        //  transactionsData(tab)
        setActiveTab(tab)
        // setClientMangeSearch("")
    }


    const handleChange = (e) => {
        const { name, value } = e.target;

        // Update formData
        setFormData((prev) => ({ ...prev, [name]: value }));

        // Real-time validation
        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };

            // Validation rules
            if (name === "name") {
                if (!value || value.length > 35) {
                    newErrors.name = "Title is required and max 35 characters.";
                } else {
                    delete newErrors.name;
                }
            }

            if (name === "tagline") {
                if (!value || value.length > 30) {
                    newErrors.tagline = "Tagline is required and max 30 characters.";
                } else {
                    delete newErrors.tagline;
                }
            }

            if (name === "textButton") {
                if (!value || value.length > 20) {
                    newErrors.textButton = "Button text is required and max 20 characters.";
                } else {
                    delete newErrors.textButton;
                }
            }

            return newErrors;
        });
    };


    const handleLogoChange = (event) => {
        const selectedFile = event.target.files[0];
        if (!selectedFile) return;

        const allowedTypes = ["image/jpeg", "image/png", "image/heic", "image/jpg"];
        const fileSizeLimit = 1048576; // 1MB

        if (!allowedTypes.includes(selectedFile.type)) {
            toast.error("Only JPG, PNG, and HEIC files are allowed!");
            return;
        }

        if (selectedFile.size > fileSizeLimit) {
            toast.error("Logo size should not exceed 1MB.");
            return;
        }

        const previewUrl = URL.createObjectURL(selectedFile);
        setFormData(prev => ({ ...prev, logo: previewUrl }));
        setFilesData(prev => ({ ...prev, logo: selectedFile }));
    };


    const handleImageChange = (event) => {
        const selectedFile = event.target.files[0];
        if (!selectedFile) return;

        const allowedTypes = ["image/png"];
        const fileSizeLimit = 1048576 * 5; // 5MB

        if (!allowedTypes.includes(selectedFile.type)) {
            toast.error("Only PNG files are allowed!");
            return;
        }

        if (selectedFile.size > fileSizeLimit) {
            toast.error("Image size should not exceed 5MB.");
            return;
        }

        const reader = new FileReader();

        reader.onload = (e) => {
            const image = new Image();
            image.onload = () => {
                const { width, height } = image;

                if (width !== 210 || height !== 325) {
                    toast.error("Image must be 210px × 325px.");
                    return;
                }

                setFormData(prev => ({ ...prev, image: e.target.result }));
                setFilesData(prev => ({ ...prev, image: selectedFile }));
            };

            image.onerror = () => {
                toast.error("Invalid image file.");
            };

            image.src = e.target.result;
        };

        reader.readAsDataURL(selectedFile);
    };



    // const handleUploadSubmit = async () => {
    //     const newErrors = {};
    //     console.log("formData.name.length", formData.name.length)

    //     if (!formData.name || formData.name.length > 35) {
    //         newErrors.name = "Title is required and max 35 characters.";
    //     }

    //     if (!formData.tagline || formData.tagline.length > 30) {
    //         newErrors.tagline = "Tagline is required and max 30 characters.";
    //     }

    //     if (!formData.textButton || formData.textButton.length > 20) {
    //         newErrors.textButton = "Button text is required and max 20 characters.";
    //     }

    //     if (!formData.logo) {
    //         newErrors.logo = "Logo is required.";
    //     }

    //     if (!formData.image) {
    //         newErrors.image = "Image is required.";
    //     }

    //     setErrors(newErrors);
    //     // return false
    //     if (Object.keys(newErrors).length > 0) return;
    //     const ObjectID = require("bson-objectid");
    //     setBtnLoader(true);

    //     const updatedFormData = { ...formData };

    //     for (const [key, file] of Object.entries(filesData)) {
    //         if (!file) continue;

    //         try {
    //             const timestamp = Date.now();
    //             const fileExtension = file.name.split('.').pop();
    //             const uniqueFileId = new ObjectID().toString();
    //             const uploadFilePath = `${appname}/${uniqueFileId}/${file.name.replace(/ /g, '_').split('.')[0]}_${key}_image_${timestamp}.${fileExtension}`;
    //             const bucket = window?.site?.common?.resourceBucket;

    //             const uploadData = {
    //                 source_bucket: bucket,
    //                 sourcepath: uploadFilePath
    //             };

    //             // 1. Get signed URL
    //             const uploadUrlResponse = await axios.post(
    //                 `${lambda}/uploadURL?appname=${appname}`,
    //                 uploadData,
    //                 { headers: { 'Content-Type': 'application/json' } }
    //             );

    //             const signedUrl = uploadUrlResponse.data?.result;
    //             if (!signedUrl) throw new Error("No signed URL returned");

    //             // 2. Upload the file to S3
    //             await axios.put(signedUrl, file, {
    //                 headers: {
    //                     'Content-Type': file.type,
    //                     'Cache-Control': 'no-cache'
    //                 }
    //             });

    //             // 3. Set final uploaded path
    //             updatedFormData[key] = uploadFilePath;

    //         } catch (error) {
    //             console.error(`Error uploading ${key}:`, error);
    //             setToastMessage(`File upload failed for ${key}.`);
    //             setToastType("error");
    //         }
    //     }

    //     // Now send to backend
    //     await handleCreate(updatedFormData);
    //     setBtnLoader(false);
    // };

    // const handleEditSubmit = async () => { 
    //     const newErrors = {};
    //     console.log("formData.name.length", formData.name.length)

    //     if (!formData.name || formData.name.length > 35) {
    //         newErrors.name = "Title is required and max 35 characters.";
    //     }

    //     if (!formData.tagline || formData.tagline.length > 30) {
    //         newErrors.tagline = "Tagline is required and max 30 characters.";
    //     }

    //     if (!formData.textButton || formData.textButton.length > 20) {
    //         newErrors.textButton = "Button text is required and max 20 characters.";
    //     }

    //     if (!formData.logo) {
    //         newErrors.logo = "Logo is required.";
    //     }

    //     if (!formData.image) {
    //         newErrors.image = "Image is required.";
    //     }

    //     setErrors(newErrors);
    //     if (Object.keys(newErrors).length > 0) return;
    //     setBtnLoader(true);
    //     const updatedFormData = { ...formData };
    //     const payload = {
    //         createdBy: {
    //             name: userData?.name,
    //             userid: useruniqueid,
    //         },
    //         name: updatedFormData?.name,
    //         logo: updatedFormData?.logo,
    //         image: updatedFormData?.image,
    //         tagline: updatedFormData?.tagline,
    //         textButton: updatedFormData?.textButton,
    //         status: updatedFormData?.status,
    //         theme: updatedFormData?.theme,
    //     };
    //     if (updatedFormData?.landingThemeId) {
    //         const urlLink = lambda + '/editLandingTheme?appname=' + appname + (updatedFormData?.landingThemeId ? "&landingThemeId=" + updatedFormData?.landingThemeId : "");
    //         const response = await axios.post(urlLink, payload);
    //         console.log("response?.data", response?.data, response?.data?.result, response?.result)
    //         if (response && response?.data && response?.data?.result === "Updated Successfully") {
    //             setBtnLoader(false);
    //             toast.success("Landing Theme Updated Successfully");
    //             getLandingTheme()
    //         }

    //     }
    // }

    // const handleCreate = async (data) => {
    //     console.log("data", data)
    //     const payload = {
    //         createdBy: {
    //             name: userData?.name,
    //             userid: useruniqueid,
    //         },
    //         name: data?.name,
    //         logo: data?.logo,
    //         image: data?.image,
    //         tagline: data?.tagline,
    //         textButton: data?.textButton,
    //         status: data?.status,
    //         theme: data?.theme,
    //     };

    //     try {
    //         const token = localStorage.getItem("token");
    //         if (data?.landingThemeId) {
    //             const urlLink = lambda + '/editLandingTheme?appname=' + appname + (data?.landingThemeId ? "&landingThemeId=" + data?.landingThemeId : "");
    //             const response = await axios.post(urlLink, payload);
    //             console.log("response?.data", response?.data, response?.data?.result, response?.result)
    //             if (response && response?.data && response?.data?.result === "Updated Successfully") {
    //                 toast.success("Landing Theme Updated Successfully");
    //                 getLandingTheme()
    //             }

    //         } else {
    //             const response = await axios.post(
    //                 `${lambda}landingTheme?appname=${appname}`,
    //                 payload
    //             );
    //             if (response && response?.data && response?.data?.result == "Added Successfully") {
    //                 toast.success("Landing Theme Created Successfully");
    //                 getLandingTheme()
    //             }
    //         }

    //         // setFormData({
    //         //     name: "",
    //         //     logo: "",
    //         //     tagline: "",
    //         //     textButton: "",
    //         //     image: ""
    //         // });
    //         // setFilesData({ logo: null, image: null });

    //     } catch (error) {
    //         console.error("Error while saving:", error);
    //         setToastMessage("Something went wrong.");
    //         setToastType("error");
    //     }
    // };

   
   
    const handleUploadSubmit = async () => {
        const newErrors = {};
    
        if (!formData.name || formData.name.length > 35) {
            newErrors.name = "Title is required and max 35 characters.";
        }
    
        if (!formData.tagline || formData.tagline.length > 30) {
            newErrors.tagline = "Tagline is required and max 30 characters.";
        }
    
        if (!formData.textButton || formData.textButton.length > 20) {
            newErrors.textButton = "Button text is required and max 20 characters.";
        }
    
        if (!formData.logo) {
            newErrors.logo = "Logo is required.";
        }
    
        if (!formData.image) {
            newErrors.image = "Image is required.";
        }
    
        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) return;
    
        setBtnLoader(true);
    
        const ObjectID = require("bson-objectid");
        const updatedFormData = { ...formData };
    
        // Upload new files if provided
        for (const [key, file] of Object.entries(filesData)) {
            if (!file) continue; // No new file uploaded for this field
    
            try {
                const timestamp = Date.now();
                const fileExtension = file.name.split('.').pop();
                const uniqueFileId = new ObjectID().toString();
                const uploadFilePath = `${appname}/${uniqueFileId}/${file.name.replace(/ /g, '_').split('.')[0]}_${key}_image_${timestamp}.${fileExtension}`;
                const bucket = window?.site?.common?.resourceBucket;
    
                const uploadData = {
                    source_bucket: bucket,
                    sourcepath: uploadFilePath
                };
    
                // Get signed URL
                const uploadUrlResponse = await axios.post(
                    `${lambda}/uploadURL?appname=${appname}`,
                    uploadData,
                    { headers: { 'Content-Type': 'application/json' } }
                );
    
                const signedUrl = uploadUrlResponse.data?.result;
                if (!signedUrl) throw new Error("No signed URL returned");
    
                // Upload to S3
                await axios.put(signedUrl, file, {
                    headers: {
                        'Content-Type': file.type,
                        'Cache-Control': 'no-cache'
                    }
                });
    
                // Set S3 path in formData
                updatedFormData[key] = uploadFilePath;
    
            } catch (error) {
                console.error(`Error uploading ${key}:`, error);
                setToastMessage(`File upload failed for ${key}.`);
                setToastType("error");
                setBtnLoader(false);
                return;
            }
        }
    
        // Prepare payload
        const payload = {
            createdBy: {
                name: userData?.name,
                userid: useruniqueid,
            },
            name: updatedFormData?.name,
            logo: updatedFormData?.logo,
            image: updatedFormData?.image,
            tagline: updatedFormData?.tagline,
            textButton: updatedFormData?.textButton,
            status: updatedFormData?.status,
            theme: updatedFormData?.theme,
        };
    
        try {
            if (updatedFormData?.landingThemeId) {
                // Edit
                const urlLink = `${lambda}/editLandingTheme?appname=${appname}&landingThemeId=${updatedFormData.landingThemeId}`;
                const response = await axios.post(urlLink, payload);
    
                if (response?.data?.result === "Updated Successfully") {
                    toast.success("Landing Theme Updated Successfully");
                    getLandingTheme();
                }
            } else {
                // Create
                const response = await axios.post(
                    `${lambda}/landingTheme?appname=${appname}`,
                    payload
                );
    
                if (response?.data?.result === "Added Successfully") {
                    toast.success("Landing Theme Created Successfully");
                    getLandingTheme();
                }
            }
    
            // Optionally reset form
            // setFormData({
            //     name: "",
            //     logo: "",
            //     tagline: "",
            //     textButton: "",
            //     image: ""
            // });
            // setFilesData({ logo: null, image: null });
    
        } catch (error) {
            console.error("Error while saving:", error);
            setToastMessage("Something went wrong.");
            setToastType("error");
        }
    
        setBtnLoader(false);
    };
    
   
   
    const getLandingTheme = async (data) => {

        try {
            const token = localStorage.getItem("token");
            let response = await axios.get(
                `${lambda}getLandingTheme?appname=${appname}`
            );
            setFormData(response?.data?.result?.[0]);

        } catch (error) {
            console.error("Error while saving:", error);
            setToastMessage("Something went wrong.");
            setToastType("error");
        }
    };
    const handleRemove1 = () => {
        setFilesData([])
        setFormData({ ...formData, image: "" })
    }
    const handleRemove = () => {
        setFilesData([])
        setFormData({ ...formData, logo: "" })
    }
    console.log("formData", formData, image + formData?.logo)
    console.log("errors", errors)
    console.log("data", data)
    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <Sidebar />

                <div className="main-content user-management visitor-app-page">
                    <div className="page-content">
                        <div className="container-fluid">
                            <div className="row mb-4 breadcrumb">
                                <div className="col-lg-12">
                                    <h4 className="mb-2 card-title">VISITOR APP SETTINGS</h4>
                                </div>
                            </div>

                            <div className="row table-data">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body edit-store visitor-settings">
                                            <ul className="nav nav-tabs nav-tabs-custom" role="tablist">
                                                <li className="nav-item">
                                                    <a className={`nav-link ${activeTab === 'landingScreen' ? 'active' : ''}`}
                                                        onClick={() => handleActiveTab('landingScreen')} role="tab">
                                                        <span>LANDING SCREEN CONFIGURATIONS</span>
                                                    </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className={`nav-link ${activeTab === 'theme' ? 'active' : ''}`}
                                                        onClick={() => handleActiveTab('theme')} role="tab">
                                                        <span>THEME CONFIGURATIONS</span>
                                                    </a>
                                                </li>
                                            </ul>

                                            <div className="tab-content text-muted">
                                                {activeTab === 'landingScreen' ? (
                                                    <div className="tab-pane active show">
                                                        <div className="row landing-wrapper">
                                                            <div className="col-md-10">
                                                                <div className="row">
                                                                    <div className="col-md-6">
                                                                        <label className="form_label" htmlFor="logo-upload">Upload Logo</label>
                                                                        <div className="upload-zone input-group mb-2 mr-sm-2">
                                                                            {formData?.logo ? (
                                                                                <div className="upload-icon mt-1">
                                                                                    <div className="img_block add_img_block">
                                                                                        {/* Close icon to remove logo */}
                                                                                        <span
                                                                                            className="material-icons-outlined thumbnail-cls-icon"
                                                                                            onClick={() => handleRemove("logo")}
                                                                                        >
                                                                                            close
                                                                                        </span>

                                                                                        {/* Display logo preview */}
                                                                                        <img
                                                                                            id="activeImg"
                                                                                            src={
                                                                                                formData.logo.startsWith("blob:") || formData.logo.startsWith("data:")
                                                                                                    ? formData.logo
                                                                                                    : image + formData.logo
                                                                                            }
                                                                                            width={150}
                                                                                            alt="Uploaded Logo"
                                                                                            onError={(e) => {
                                                                                                e.target.onerror = null;
                                                                                                e.target.src = "/images/placeholder.png"; // fallback image
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            ) : (
                                                                                <div>
                                                                                    <input
                                                                                        type="file"
                                                                                        id="logo-upload"
                                                                                        accept="image/jpeg, image/png, image/heic, image/jpg"
                                                                                        className="d-none"
                                                                                        onChange={handleLogoChange}
                                                                                    />
                                                                                    <label htmlFor="logo-upload" className="stroke-button">
                                                                                        <span className="material-icons">file_upload</span>
                                                                                    </label>
                                                                                    {errors?.logo && <span className="error-text">{errors.logo}</span>}
                                                                                </div>
                                                                            )}
                                                                        </div>

                                                                    </div>


                                                                    <div className="col-md-6">
                                                                        <div className="input-field">
                                                                            <label className="form_label">Main title<span className="required">*</span></label>
                                                                            <input className={`form-control ${errors.tagline ? "is-invalid" : ""}`} placeholder="No Wait, No Hassle, Save your Spot!"
                                                                                name="name" value={formData.name} onChange={handleChange} />
                                                                            {errors.name && <span className="error-text">{errors.name}</span>}
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-6 mt-3">
                                                                        <div className="input-field">
                                                                            <label className="form_label">
                                                                                Tagline<span className="required">*</span>
                                                                            </label>
                                                                            <input
                                                                                className={`form-control ${errors.tagline ? "is-invalid" : ""}`}
                                                                                placeholder="Say Goodbye to long waits"
                                                                                name="tagline"
                                                                                value={formData.tagline}
                                                                                onChange={handleChange}
                                                                            />
                                                                            {errors.tagline && (
                                                                                <span className="error-text">{errors.tagline}</span>
                                                                            )}
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-6 mt-3">
                                                                        <div className="input-field">
                                                                            <label className="form_label">Text on Button<span className="required">*</span></label>
                                                                            <input className="form-control" placeholder="Get Started"
                                                                                name="textButton" value={formData.textButton} onChange={handleChange} />
                                                                            {errors.textButton && <span className="error-text">{errors.textButton}</span>}
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-6 mt-3">
                                                                        <label className="form_label" htmlFor="image-upload">Upload Image</label>

                                                                        <div className="upload-zone input-group mb-2 mr-sm-2">
                                                                            {formData?.image ? (
                                                                                <div className="upload-icon mt-1">
                                                                                    <div className="img_block add_img_block">
                                                                                        {/* Remove uploaded image */}
                                                                                        <span
                                                                                            className="material-icons-outlined thumbnail-cls-icon"
                                                                                            onClick={() => handleRemove1("image")}
                                                                                        >
                                                                                            close
                                                                                        </span>

                                                                                        {/* Image Preview */}
                                                                                        <img
                                                                                            id="activeImg"
                                                                                            src={
                                                                                                formData.image.startsWith("blob:") || formData.image.startsWith("data:")
                                                                                                    ? formData.image
                                                                                                    : image + formData.image
                                                                                            }
                                                                                            width={150}
                                                                                            height="auto"
                                                                                            alt="Uploaded Image"
                                                                                            onError={(e) => {
                                                                                                e.target.onerror = null;
                                                                                                e.target.src = "/images/placeholder.png"; // Fallback image
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            ) : (
                                                                                <div>
                                                                                    <input
                                                                                        type="file"
                                                                                        id="image-upload"
                                                                                        accept="image/png"
                                                                                        className="d-none"
                                                                                        onChange={handleImageChange}
                                                                                    />
                                                                                    <label htmlFor="image-upload" className="stroke-button">
                                                                                        <span className="material-icons">file_upload</span>
                                                                                    </label>
                                                                                    {errors?.image && (
                                                                                        <span className="error-text">{errors.image}</span>
                                                                                    )}
                                                                                </div>
                                                                            )}

                                                                            {/* File requirements */}
                                                                            <div className="file_requirements">
                                                                                <p>Ideal image size: Width 210px × Height 325px</p>
                                                                                <p>Image format: PNG only</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>



                                                                    {/* <div className="col-md-6 mt-3">
                                                                        <button className="fill-btn-style" onClick={handleUploadSubmit} disabled={btnLoader}>
                                                                            {btnLoader ? (
                                                                                <img src={`/images/loading.svg`} className="loading-icon" alt="Loading" />
                                                                            ) : (
                                                                                'Save'
                                                                            )}
                                                                        </button>

                                                                        
                                                                    </div> */}
                                                                    <div className="col-md-6 mt-3"></div>
                                                                    <div className="col-md-6 mt-3">
                                                                        <button
                                                                            id="saveLandingBtn"
                                                                            className="fill-btn-style"
                                                                            onClick={handleUploadSubmit}
                                                                            disabled={btnLoader}
                                                                        >
                                                                            {btnLoader &&
                                                                                <img
                                                                                    id="loadingIcon"
                                                                                    src={`${image}${appname}/images/web/rotate_right.svg`}
                                                                                    className="loading-icon me-2"
                                                                                    alt="Loading"
                                                                                />
                                                                            }
                                                                           {formData?.landingThemeId ? "Update" : "Save"} 
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-2">
                                                                <div className="screen-showing">
                                                                    <img src="./assets/img/LandingPage-screen-mobile.svg" className="img-fluid" alt="Mobile Preview" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <Theme />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ToastContainer
                        id="toastContainer"
                        position="bottom-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover={false}
                        theme="light"
                    />
                    <Footer />

                   
                </div>
            </div>
        </>
    );
};

export default LandingScreen;
